// extracted by mini-css-extract-plugin
export default {"wrapper":"Overlay-module__wrapper___3FIMT","logo":"Overlay-module__logo___YhzSR","visible":"Overlay-module__visible___nCLqf"};